export default __webpack_public_path__ + "static/media/game.15bb3302.gif";